import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FilterValueType } from '../../filtered-search.component';

@Component({
  selector: 'selection-filter',
  styleUrl: '../filtered-search-option.component.scss',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule, L10nTranslatePipe],
  template: `
    <mat-form-field
      class="filter-form"
      appearance="outline"
      (click)="$event.stopPropagation(); $event.preventDefault()"
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
    >
      <mat-label>
        {{ 'Filter.Value' | translate: locale.language }}
      </mat-label>
      <mat-select [formControl]="control" [attr.data-test]="'filter-select'">
        @for (option of values; track $index) {
          <mat-option [value]="option" [attr.data-test]="'filter-select-option-' + option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionFilterComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);

  @Input() control: FormControl<FilterValueType>;
  @Input() values: string[] | { value: unknown, label: string, icon?: string }[];
}
